import React from "react";

import {DeliveryStatus} from "../../../../../Components/DeliveryStatus";
import {StockItemsContext} from "../../../../../Contexts/StockItemsContext";
import Spinner from "../../../../../Components/Common/Spinner";

const TableTdDelivery = ({productCode, unitCode}) => {
    const {productStockList, loadingStockList} = React.useContext(StockItemsContext);
    if (!productCode) {
        return <td width="75" className="mx-auto"></td>;
    }

    return (
        <td width="75" className="mx-auto">
            {loadingStockList ? <Spinner/> :
                <div>
                    <DeliveryStatus status={productStockList.get(`${productCode}-${unitCode}`)}/>
                </div>
            }
        </td>
    )
}


export default TableTdDelivery;